import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { AuthLoading } from "@/components/shared/app-layout/auth-loading";
import styles from "@/components/shared/app-layout/layout.module.css";
import { Sidebar } from "@/components/shared/app-layout/sidebar";
import { useAppSelector } from "@/store";

export const AppLayout = () => {
    const accessToken = useAppSelector((state) => state.auth.accessToken);

    if (!accessToken) {
        return <AuthLoading />;
    }

    return (
        <div className={styles.layout}>
            <Sidebar />
            <div className={styles.content}>
                <Suspense>
                    <Outlet />
                </Suspense>
            </div>
        </div>
    );
};
